<!--
    Summary:
        无创产前基因检测 Non-invasive Prenatal Test
        hkml.exhibition.web - n-prenata-test
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-n-prenata-test" title="n-prenata-test">
    <sub-banner>
      <img src="../../../assets/images/projects/n-prenata-test/p1.jpg"/>
      <div slot="title">
        {{$t('NPrenatalTest.p1_title')}}
      </div>
      <a href="/" slot="action">{{$t('NPrenatalTest.p1_action')}}</a>
    </sub-banner>
    <p2-n-prenata-test2></p2-n-prenata-test2>
    <p3-n-prenata-test3></p3-n-prenata-test3>
    <p4-n-prenata-test4></p4-n-prenata-test4>
    <p5-n-prenata-test-type></p5-n-prenata-test-type>
    <p6-n-prenata-test-compare></p6-n-prenata-test-compare>


    <p6-advantages></p6-advantages>
    <p7-procedures></p7-procedures>
    <p8-attention></p8-attention>
  </div>
</template>

<script>
  import SubBanner from "@/components/sub-banner";
  import P6Advantages from "./p6-advantages";
  import P7Procedures from "../y-dna-test/p7-procedures";
  import P8Attention from "../y-dna-test/p8-attention";
  import P2NPrenataTest2 from "./p2-n-prenata-test2";
  import P3NPrenataTest3 from "./p3-n-prenata-test3";
  import P4NPrenataTest4 from "./p4-n-prenata-test4";
  import P5NPrenataTestType from "./p5-n-prenata-test-type";
  import P6NPrenataTestCompare from "./p6-n-prenata-test-compare";

  export default {
    name: "n-prenata-test",
    components: {P6NPrenataTestCompare, P5NPrenataTestType, P4NPrenataTest4, P3NPrenataTest3, P2NPrenataTest2, P8Attention, P7Procedures, SubBanner, P6Advantages}
  }
</script>

<style lang="scss">
  .en .v-n-prenata-test{
    p {
      font-size: 1.20vw;
    }
  }
</style>
<style lang="scss">
  .v-n-prenata-test {
    p {
      font-size: 1.70vw;
      line-height: 3.13vw;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0;
      color: #000000;
    }

  }
</style>




// WEBPACK FOOTER //
// src/view/projects/n-prenata-test/n-prenata-test.vue